import React, { useEffect, useState } from "react";
import { IoCalendarNumberSharp } from "react-icons/io5";
import { FaClock } from "react-icons/fa";
import { getAllbooking } from "../api/booking";
import { RxCross2 } from "react-icons/rx";

const Dashboard = () => {
  const [bookings, setBooking] = useState([]);
  const [viewOpen, setViewOpen] = useState(false);
  const [viewBill, setViewBill] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);

  useEffect(() => {
    getAllbooking()
      .then((res) => setBooking(res.data))
      .catch((err) => console.log(err));
  }, []);

  const handleViewDetail = (event) => {
    setSelectedEvent(event);
    setViewOpen(true);
  };

  return (
   <div className="px-5 md:px-10 mt-[5%]">
      {/* Top Section */}
      <div className="flex justify-between flex-wrap gap-6">
       
        <div className=" w-full md:w-[300px] mb-5">
          <h4 className="text-xl font-bold flex items-center text-nowrap gap-2 text-primary mb-5">
           வணக்கம், எல்.டி.எஸ் மஹால் <span className="text-[#eac000] text-2xl">👋</span>
          </h4>
          <div className="flex justify-center items-center bg-[#f1f8f6]">
            <div className="text-secondary p-4 text-center rounded-xl shadow-md w-full">
              <div className="flex flex-col items-center gap-2">
                <IoCalendarNumberSharp fontSize={30} className="text-[#eac000]" />
                <span className="font-medium text-sm">முன்பதிவுகள்</span>
                <span className="font-bold text-2xl">{bookings.length}</span>
              </div>
            </div>
          </div>
        </div>

      
        <div className="w-full md:w-[300px]  flex flex-col ">
          <h1 className="text-center font-bold text-primary text-xl mb-5">வரவிருக்கும் நிகழ்வுகள்</h1>
          <div className="">
            <div className="overflow-y-auto max-h-[300px] space-y-3 pr-1 scrollbar-thin scrollbar-thumb-gray-300">
              {bookings.length > 0 ? (
                bookings.map((event, index) => (
                  <div key={index} className="bg-[#f1f8f6] p-3 rounded-xl shadow-sm">
                    <div className="text-center">
                      <div className="text-secondary font-bold text-base mb-3">
                        {event.event}
                      </div>
                      <div className="text-sm text-gray-700">
                        <div className="font-medium mb-1">
                          நேரம்: {event.startTime} - {event.endTime}
                        </div>
                        <div className="font-medium mb-1">
                         தேதி: {event.date?.slice(0, 10)}
                        </div>
                      </div>
                      <button
                        onClick={() => handleViewDetail(event)}
                        className="mt-2 text-xs px-3 py-1.5 rounded-md font-semibold bg-primary text-white"
                      >
                       விவரம் பார்க்கவும்
                      </button>
                    </div>
                  </div>
                ))
              ) : (
                <div className="text-center text-gray-500 bg-gray-100 p-4 rounded-xl shadow-sm">
                 வரவிருக்கும் நிகழ்வுகள் இல்லை.
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* View Detail Modal */}
      {viewOpen && selectedEvent && (
        <div className="fixed inset-0 bg-black bg-opacity-40 z-50 flex justify-center items-center px-4">
          <div className="w-full max-w-xl bg-white rounded-lg shadow-2xl p-6 overflow-y-auto max-h-[90vh]">
            <div className="flex justify-end">
              <RxCross2
                size={22}
                className="cursor-pointer text-gray-500 hover:text-red-500"
                onClick={() => setViewOpen(false)}
              />
            </div>
            <h2 className="text-xl font-semibold text-primary mb-4">
             நிகழ்வு விவரங்கள்: {selectedEvent.event}
            </h2>
            <p className="mb-2 text-sm">
              நேரம்: {selectedEvent.startTime} - {selectedEvent.endTime}
            </p>
            <div className="space-y-2 mb-4">
              {selectedEvent?.feilds?.map((field, i) => (
                <p key={i} className="text-sm text-gray-700">
                  <span className="font-semibold">{field?.label}:</span> {field?.value}
                </p>
              ))}
            </div>
            <hr />
            <div className="bg-gray-50 p-4 rounded-lg border space-y-2 mt-3">
              <p className="text-[11px] md:text-sm text-gray-800">
                <span className="font-semibold">கட்டண முறை:</span>{" "}
                {selectedEvent.paymentMode || "N/A"}
              </p>
              <p className="text-[11px] md:text-sm text-gray-800">
                <span className="font-semibold">அட்வான்ஸ் தொகை:</span> ₹
                {selectedEvent.advanceAmount || "0"}
              </p>
              <p className="text-[11px] md:text-sm text-gray-800">
                <span className="font-semibold">மொத்த தொகை:</span> ₹
                {selectedEvent.totalAmount || "0"}
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Dashboard;